export const Contact = () => (
  <div className="min-h-screen bg-paper text-ink py-16">
    <div className="max-w-4xl mx-auto px-6">
      <h1 className="font-serif text-4xl md:text-5xl mb-8" data-testid="contact-title">
        Contact <em className="italic">us</em>
      </h1>
      <div className="space-y-4 text-muted font-serif">
        <p>Questions, feedback, or just want to say hello? We are here.</p>
        <p><strong className="text-ink">Email:</strong> hello@capetownmonthly.com</p>
        <p><strong className="text-ink">Based in:</strong> Cape Town, South Africa</p>
      </div>
    </div>
  </div>
);
